// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { TrustBeneficiariesList_BeneficiaryFragment } from '../../../trusts/TrustBeneficiariesList/graphql/TrustBeneficiariesList.fragments.generated';
import { TrustTrusteesList_SuccessorTrusteeFragment, TrustTrusteesList_TrusteeFragment } from '../../../trusts/TrustTrusteesList/graphql/TrustTrusteesList.fragments.generated';
import { TrustAdvisorsList_TrustAdvisorFragment } from '../../../trusts/TrustAdvisorsList/graphql/TrustAdvisorsList.fragments.generated';
import { gql } from '@apollo/client';
import { TrustBeneficiariesList_BeneficiaryFragmentDoc } from '../../../trusts/TrustBeneficiariesList/graphql/TrustBeneficiariesList.fragments.generated';
import { TrustTrusteesList_SuccessorTrusteeFragmentDoc, TrustTrusteesList_TrusteeFragmentDoc } from '../../../trusts/TrustTrusteesList/graphql/TrustTrusteesList.fragments.generated';
import { TrustAdvisorsList_TrustAdvisorFragmentDoc } from '../../../trusts/TrustAdvisorsList/graphql/TrustAdvisorsList.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TestamentaryEntitySummaryPanel_TestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, kind: Types.TestamentaryEntityKind, taxStatus?: Types.NonTrustEntityTaxStatus | null, inEstateStatus?: Types.EntityInEstateStatus | null, survivingSpouseStateInEstateStatus?: Types.EntityInEstateStatus | null, displayName: string, gstStatus?: Types.EntityGstStatus | null, description?: string | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, beneficiariesAfterBothGrantorDeaths?: Array<(
    { __typename?: 'Beneficiary' }
    & TrustBeneficiariesList_BeneficiaryFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_SuccessorTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustTrusteesList_TrusteeFragment
  )> | null, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustAdvisorsList_TrustAdvisorFragment
  )> | null, controllingParties?: Array<{ __typename?: 'ControllingParty', id: string, individual?: { __typename?: 'ClientProfile', id: string, legalName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null }> | null };

export type TestamentaryEntitySummaryPanelQueryVariables = Types.Exact<{
  where: Types.TestamentaryEntityWhereInput;
}>;


export type TestamentaryEntitySummaryPanelQuery = { __typename?: 'Query', testamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: (
        { __typename?: 'TestamentaryEntity' }
        & TestamentaryEntitySummaryPanel_TestamentaryEntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    TestamentaryEntitySummaryPanel: 'TestamentaryEntitySummaryPanel' as const
  },
  Fragment: {
    TestamentaryEntitySummaryPanel_TestamentaryEntity: 'TestamentaryEntitySummaryPanel_TestamentaryEntity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TestamentaryEntitySummaryPanel_TestamentaryEntityFragmentDoc = gql`
    fragment TestamentaryEntitySummaryPanel_TestamentaryEntity on TestamentaryEntity {
  id
  kind
  taxStatus
  inEstateStatus
  survivingSpouseStateInEstateStatus
  displayName
  gstStatus
  description
  beneficiaries {
    ...TrustBeneficiariesList_Beneficiary
  }
  beneficiariesAfterBothGrantorDeaths {
    ...TrustBeneficiariesList_Beneficiary
  }
  successorTrustees {
    ...TrustTrusteesList_SuccessorTrustee
  }
  trustees {
    ...TrustTrusteesList_Trustee
  }
  trustAdvisors {
    ...TrustAdvisorsList_TrustAdvisor
  }
  controllingParties {
    id
    individual {
      id
      legalName
    }
    organization {
      id
      name
    }
  }
}
    ${TrustBeneficiariesList_BeneficiaryFragmentDoc}
${TrustTrusteesList_SuccessorTrusteeFragmentDoc}
${TrustTrusteesList_TrusteeFragmentDoc}
${TrustAdvisorsList_TrustAdvisorFragmentDoc}`;
export const TestamentaryEntitySummaryPanelDocument = gql`
    query TestamentaryEntitySummaryPanel($where: TestamentaryEntityWhereInput!) {
  testamentaryEntities(where: $where) {
    edges {
      node {
        ...TestamentaryEntitySummaryPanel_TestamentaryEntity
      }
    }
  }
}
    ${TestamentaryEntitySummaryPanel_TestamentaryEntityFragmentDoc}`;

/**
 * __useTestamentaryEntitySummaryPanelQuery__
 *
 * To run a query within a React component, call `useTestamentaryEntitySummaryPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestamentaryEntitySummaryPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestamentaryEntitySummaryPanelQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTestamentaryEntitySummaryPanelQuery(baseOptions: Apollo.QueryHookOptions<TestamentaryEntitySummaryPanelQuery, TestamentaryEntitySummaryPanelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestamentaryEntitySummaryPanelQuery, TestamentaryEntitySummaryPanelQueryVariables>(TestamentaryEntitySummaryPanelDocument, withFetchPolicyContext(options));
      }
export function useTestamentaryEntitySummaryPanelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestamentaryEntitySummaryPanelQuery, TestamentaryEntitySummaryPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestamentaryEntitySummaryPanelQuery, TestamentaryEntitySummaryPanelQueryVariables>(TestamentaryEntitySummaryPanelDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTestamentaryEntitySummaryPanelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TestamentaryEntitySummaryPanelQuery, TestamentaryEntitySummaryPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestamentaryEntitySummaryPanelQuery, TestamentaryEntitySummaryPanelQueryVariables>(TestamentaryEntitySummaryPanelDocument, withFetchPolicyContext(options));
        }
export type TestamentaryEntitySummaryPanelQueryHookResult = ReturnType<typeof useTestamentaryEntitySummaryPanelQuery>;
export type TestamentaryEntitySummaryPanelLazyQueryHookResult = ReturnType<typeof useTestamentaryEntitySummaryPanelLazyQuery>;
export type TestamentaryEntitySummaryPanelSuspenseQueryHookResult = ReturnType<typeof useTestamentaryEntitySummaryPanelSuspenseQuery>;
export type TestamentaryEntitySummaryPanelQueryResult = Apollo.QueryResult<TestamentaryEntitySummaryPanelQuery, TestamentaryEntitySummaryPanelQueryVariables>;